<template>
  <div class="common-box margin-l6 border-t0">
    <el-row class="row-one">
      <span class="row-one-title">我的诊断报告</span>
      <a v-if="question" class="row-one-fr" href="https://www.myfund.com/NewdiagnosisOfEntrance.html?type=1" target="_block">去诊断</a>
    </el-row>
    <div v-if="!question" class="noQuestion">
      <img src="../../assets/images/diagnosis2.png" alt="">
      <p class="noQuestion-con">您暂无诊断报告 ！</p>
      <a href="https://www.myfund.com/NewdiagnosisOfEntrance.html?type=1" class="noQuestion-ask" target="_block">去诊断</a>
    </div>
    <!-- 诊断报告 -->
    <ul v-else class="diagnosticReport">
      <!-- v-show="item1.description != ''" -->
      <li :class="['diagnosticReport-con',{'isDiagnosis':item1.status == '0'}]" v-for="(item1,i1) in questionLists" :key="i1+'r'" @click="reportClick(item1)">
        <p class="diagnosticReport-text" v-for="(item2,i2) in item1.name" :key="i2+'n'">{{ item2=='......'?'......': item2.split(':')[0] + '('+ item2.split(':')[1] +')' }}</p>
        <div class="diagnosticReport-status">
          <p>{{item1.status == '0'?'诊断中...':'诊断完成'}}</p>
          <p style="font-size:14px;">{{$commonJs.timeFormat(item1.adddate, 'yyyy-mm-dd')}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      question: true,
      questionLists: []
    }
  },
  mounted () {
    this.getReports()
  },
  methods: {
    getReports () {
      this.$http.post(this.$apiPath.getIssue, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.length > 0) {
          this.question = true
          let newArr = []
          res.data.data.forEach(item => {
            if (item.description != '') {
              newArr.push(item)
            }
          })
          newArr.forEach((item, i) => {
            item.name = item.description.slice(0, -1).split('/')
            if (item.name.length > 3) {// 显示名字修改
              item.name = item.name.slice(0, 3)
              item.name.push('......')
            }
          });
          this.questionLists = newArr
        } else {
          this.question = false
        }
      }).catch(err => { })
    },
    reportClick (val) {
      val.status != '0' ? window.open('https://www.myfund.com' + val.fileurl.split('@')[1], '_blank') : 'javascript:;'
    }
  }
}
</script>

<style lang="less" scoped>
.noQuestion {
  margin: 116.5px auto;
  text-align: center;
  &-con {
    margin: 15px;
    color: @color6;
  }
  &-ask {
    display: inline-block;
    width: 110px;
    height: 30px;
    line-height: 30px;
    background: @color;
    color: @wColor;
    border-radius: 5px;
  }
}
.diagnosticReport {
  margin: 30px 0 205px 0;
  &-con {
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    width: 32.5%;
    min-height: 112px;
    background: @color;
    margin: 0 11px 11px 0;
    padding: 12px;
    color: @wColor;
    line-height: 22px;
    cursor: pointer;
    border-radius: 8px;
  }
  &-con:nth-child(3n + 3) {
    margin: 0;
  }
  &-con::before {
    position: absolute;
    bottom: 0;
    right: 4px;
    width: 84px;
    height: 78px;
    content: "";
    background: url(../../assets/images/diagnosis5.png);
  }
  &-text {
    width: 222px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-status {
    position: absolute;
    right: 4px;
    top: 50%;
    width: 31%;
    transform: translateY(-50%);
    font-size: 18px;
    text-align: center;
    line-height: 25px;
  }
  .isDiagnosis {
    background: #b1b1b1;
    cursor: default;
  }
}
</style>


